import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { ticketManagementActions as actions, notificationActions } from '../actions';
import { ticketManagementService } from '../services';

/* Add Ticket Sagas */
function* handleCreateTicketRequest() {
    const action = yield take(actions.createTicketRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.createTicket, dataParams);
        if (res.isError) {
            yield put(actions.createTicketError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createTicketSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createTicketError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Ticket Sagas */
function* handleGetTicketRequest() {
    const action = yield take(actions.getTicketRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getTicket, dataParams);
        if (res.isError) {
            yield put(actions.getTicketError(res));

        } else {
            yield put(actions.getTicketSuccess(res));
        }

    } catch (error) {
        yield put(actions.getTicketError());
    }
}

/* Get Ticket Sagas */
function* handleGetAllTicketRequest() {
    const action = yield take(actions.getAllTicketRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getAllTicket, dataParams);
        if (res.isError) {
            yield put(actions.getAllTicketError(res));

        } else {
            yield put(actions.getAllTicketSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllTicketError());
    }
}

/* Update Ticket Sagas */
function* handleUpdateTicketRequest() {
    const action = yield take(actions.updateTicketRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.updateTicket, dataParams);
        if (res.isError) {
            yield put(actions.updateTicketError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateTicketSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateTicketError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Ticket Sagas */
function* handleDeleteTicketRequest() {
    const action = yield take(actions.deleteTicketRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.deleteTicket, dataParams);
        if (res.isError) {
            yield put(actions.deleteTicketError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteTicketSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteTicketError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Ticket Sagas */
function* handleCreateTicketIssueTypeRequest() {
    const action = yield take(actions.createTicketIssueTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.createTicketIssueType, dataParams);
        if (res.isError) {
            yield put(actions.createTicketIssueTypeError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createTicketIssueTypeSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createTicketIssueTypeError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Ticket Sagas */
function* handleGetAllTicketTypeRequest() {
    const action = yield take(actions.getAllTicketTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getAllTicketType, dataParams);
        if (res.isError) {
            yield put(actions.getAllTicketTypeError(res));

        } else {
            yield put(actions.getAllTicketTypeSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllTicketTypeError());
    }
}

/* Get All Ticket Sagas */
function* handleGetTicketIssueSubTypeRequest() {
    const action = yield take(actions.getTicketIssueSubTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getTicketIssueSubType, dataParams);
        if (res.isError) {
            yield put(actions.getTicketIssueSubTypeError(res));

        } else {
            yield put(actions.getTicketIssueSubTypeSuccess(res));
        }

    } catch (error) {
        yield put(actions.getTicketIssueSubTypeError());
    }
}


/* Get Ticket By Department Sagas */
function* handleGetAllTicketIssueTypeRequest() {
    const action = yield take(actions.getAllTicketIssueTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getAllTicketIssueType, dataParams);
        if (res.isError) {
            yield put(actions.getAllTicketIssueTypeError(res));

        } else {
            yield put(actions.getAllTicketIssueTypeSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllTicketIssueTypeError());
    }
}

/* Update Ticket Sagas */
function* handleUpdateTicketTypeRequest() {
    const action = yield take(actions.updateTicketTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.updateTicketType, dataParams);
        if (res.isError) {
            yield put(actions.updateTicketTypeError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateTicketTypeSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateTicketTypeError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Ticket Sagas */
function* handleDeleteTicketTypeRequest() {
    const action = yield take(actions.deleteTicketTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.deleteTicketType, dataParams);
        if (res.isError) {
            yield put(actions.deleteTicketTypeError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteTicketTypeSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteTicketTypeError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Ticket Logs Sagas */
function* handleCreateTicketLogsRequest() {
    const action = yield take(actions.createTicketLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.createTicketLogs, dataParams);
        if (res.isError) {
            yield put(actions.createTicketLogsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createTicketLogsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createTicketLogsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Ticket Logs Sagas */
function* handleGetTicketLogsRequest() {
    const action = yield take(actions.getTicketLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getTicketLogs, dataParams);
        if (res.isError) {
            yield put(actions.getTicketLogsError(res));

        } else {
            yield put(actions.getTicketLogsSuccess(res));
        }

    } catch (error) {
        yield put(actions.getTicketLogsError());
    }
}

/* Get Ticket Logs By Department Sagas */
function* handleGetAllTicketLogsRequest() {
    const action = yield take(actions.getAllTicketLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getAllTicketLogs, dataParams);
        if (res.isError) {
            yield put(actions.getAllTicketLogsError(res));

        } else {
            yield put(actions.getAllTicketLogsSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllTicketLogsError());
    }
}

/* Update Ticket Logs Sagas */
function* handleUpdateTicketLogsRequest() {
    const action = yield take(actions.updateTicketLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.updateTicketLogs, dataParams);
        if (res.isError) {
            yield put(actions.updateTicketLogsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateTicketLogsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateTicketLogsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Ticket Logs Sagas */
function* handleDeleteTicketLogsRequest() {
    const action = yield take(actions.deleteTicketLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.deleteTicketLogs, dataParams);
        if (res.isError) {
            yield put(actions.deleteTicketLogsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteTicketLogsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteTicketLogsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Designation Sagas */
function* handleCreateTicketSettingRequest() {
    const action = yield take(actions.createTicketSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.createTicketSetting, dataParams);
        if (res.isError) {
            yield put(actions.createTicketSettingError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createTicketSettingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createTicketSettingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Designation Sagas */
function* handleGetTicketSettingRequest() {
    const action = yield take(actions.getTicketSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getTicketSetting, dataParams);
        if (res.isError) {
            yield put(actions.getTicketSettingError(res));

        } else {
            yield put(actions.getTicketSettingSuccess(res));
        }

    } catch (error) {
        yield put(actions.getTicketSettingError());
    }
}

/* Get Designation By Department Sagas */
function* handleGetAllTicketSettingRequest() {
    const action = yield take(actions.getAllTicketSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getAllTicketSetting, dataParams);
        if (res.isError) {
            yield put(actions.getAllTicketSettingError(res));

        } else {
            yield put(actions.getAllTicketSettingSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllTicketSettingError());
    }
}

/* Update Designation Sagas */
function* handleUpdateTicketSettingRequest() {
    const action = yield take(actions.updateTicketSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.updateTicketSetting, dataParams);
        if (res.isError) {
            yield put(actions.updateTicketSettingError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateTicketSettingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateTicketSettingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Designation Sagas */
function* handleDeleteTicketSettingRequest() {
    const action = yield take(actions.deleteTicketSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.deleteTicketSetting, dataParams);
        if (res.isError) {
            yield put(actions.deleteTicketSettingError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteTicketSettingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteTicketSettingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* Add Help Desk Sagas */
function* handleCreateHelpDeskRequest() {
    const action = yield take(actions.createHelpDeskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.createHelpDesk, dataParams);
        if (res.isError) {
            yield put(actions.createHelpDeskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createHelpDeskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createHelpDeskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Help Desk Sagas */
function* handleGetHelpDeskRequest() {
    const action = yield take(actions.getHelpDeskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getHelpDesk, dataParams);
        if (res.isError) {
            yield put(actions.getHelpDeskError(res));

        } else {
            yield put(actions.getHelpDeskSuccess(res));
        }

    } catch (error) {
        yield put(actions.getHelpDeskError());
    }
}

/* Get all Help Desk Sagas */
function* handleGetAllHelpDeskRequest() {
    const action = yield take(actions.getAllHelpDeskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getAllHelpDesk, dataParams);
        if (res.isError) {
            yield put(actions.getAllHelpDeskError(res));

        } else {
            yield put(actions.getAllHelpDeskSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllHelpDeskError());
    }
}

/* Update Help Desk Sagas */
function* handleUpdateHelpDeskRequest() {
    const action = yield take(actions.updateHelpDeskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.updateHelpDesk, dataParams);
        if (res.isError) {
            yield put(actions.updateHelpDeskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateHelpDeskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateHelpDeskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Help Desk Sagas */
function* handleDeleteHelpDeskRequest() {
    const action = yield take(actions.deleteHelpDeskRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.deleteHelpDesk, dataParams);
        if (res.isError) {
            yield put(actions.deleteHelpDeskError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteHelpDeskSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteHelpDeskError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Help Desk Sagas */
function* handleGetTicketSummaryRequest() {
    const action = yield take(actions.getTicketSummaryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(ticketManagementService.getTicketSummary, dataParams);
        if (res.isError) {
            yield put(actions.getTicketSummaryError(res));

        } else {
            yield put(actions.getTicketSummarySuccess(res));

        }
    } catch (error) {
        yield put(actions.getTicketSummaryError());

    }
}




/* -----------Watchers------------- */
function* handleCreateTicketWatcher() {
    yield takeEvery(
        actions.createTicketRequest,
        handleCreateTicketRequest,
    );
}

function* handleGetTicketWatcher() {
    yield takeEvery(
        actions.getTicketRequest,
        handleGetTicketRequest,
    );
}

function* handleGetAllTicketWatcher() {
    yield takeEvery(
        actions.getAllTicketRequest,
        handleGetAllTicketRequest,
    );
}

function* handleUpdateTicketWatcher() {
    yield takeEvery(
        actions.updateTicketRequest,
        handleUpdateTicketRequest,
    );
}

function* handleDeleteTicketWatcher() {
    yield takeEvery(
        actions.deleteTicketRequest,
        handleDeleteTicketRequest,
    );
}

function* handleCreateTicketIssueTypeWatcher() {
    yield takeEvery(
        actions.createTicketIssueTypeRequest,
        handleCreateTicketIssueTypeRequest,
    );
}

function* handleGetAllTicketTypeWatcher() {
    yield takeEvery(
        actions.getAllTicketTypeRequest,
        handleGetAllTicketTypeRequest,
    );
}

function* handleGetAllTicketIssueTypeWatcher() {
    yield takeEvery(
        actions.getAllTicketIssueTypeRequest,
        handleGetAllTicketIssueTypeRequest,
    );
}

function* handleUpdateTicketTypeWatcher() {
    yield takeEvery(
        actions.updateTicketTypeRequest,
        handleUpdateTicketTypeRequest,
    );
}

function* handleDeleteTicketTypeWatcher() {
    yield takeEvery(
        actions.deleteTicketTypeRequest,
        handleDeleteTicketTypeRequest,
    );
}

function* handleCreateTicketLogsWatcher() {
    yield takeEvery(
        actions.createTicketLogsRequest,
        handleCreateTicketLogsRequest,
    );
}

function* handleGetTicketLogsWatcher() {
    yield takeEvery(
        actions.getTicketLogsRequest,
        handleGetTicketLogsRequest,
    );
}

function* handleGetAllTicketLogsWatcher() {
    yield takeEvery(
        actions.getAllTicketLogsRequest,
        handleGetAllTicketLogsRequest,
    );
}

function* handleUpdateTicketLogsWatcher() {
    yield takeEvery(
        actions.updateTicketLogsRequest,
        handleUpdateTicketLogsRequest,
    );
}

function* handleDeleteTicketLogsWatcher() {
    yield takeEvery(
        actions.deleteTicketLogsRequest,
        handleDeleteTicketLogsRequest,
    );
}

function* handleCreateTicketSettingWatcher() {
    yield takeEvery(
        actions.createTicketSettingRequest,
        handleCreateTicketSettingRequest,
    );
}

function* handleGetTicketSettingWatcher() {
    yield takeEvery(
        actions.getTicketSettingRequest,
        handleGetTicketSettingRequest,
    );
}

function* handleGetAllTicketSettingWatcher() {
    yield takeEvery(
        actions.getAllTicketSettingRequest,
        handleGetAllTicketSettingRequest,
    );
}

function* handleUpdateTicketSettingWatcher() {
    yield takeEvery(
        actions.updateTicketSettingRequest,
        handleUpdateTicketSettingRequest,
    );
}

function* handleDeleteTicketSettingWatcher() {
    yield takeEvery(
        actions.deleteTicketSettingRequest,
        handleDeleteTicketSettingRequest,
    );
}
function* handleGetTicketIssueSubTypeWatcher() {
    yield takeEvery(
        actions.getTicketIssueSubTypeRequest,
        handleGetTicketIssueSubTypeRequest,
    );
}


function* handleCreateHelpDeskWatcher() {
    yield takeEvery(
        actions.createHelpDeskRequest,
        handleCreateHelpDeskRequest,
    );
}

function* handleGetHelpDeskWatcher() {
    yield takeEvery(
        actions.getHelpDeskRequest,
        handleGetHelpDeskRequest,
    );
}

function* handleGetAllHelpDeskWatcher() {
    yield takeEvery(
        actions.getAllHelpDeskRequest,
        handleGetAllHelpDeskRequest,
    );
}

function* handleUpdateHelpDeskWatcher() {
    yield takeEvery(
        actions.updateHelpDeskRequest,
        handleUpdateHelpDeskRequest,
    );
}

function* handleDeleteHelpDeskWatcher() {
    yield takeEvery(
        actions.deleteHelpDeskRequest,
        handleDeleteHelpDeskRequest,
    );
}

function* handleGetTicketSummaryWatcher() {
    yield takeEvery(
        actions.getTicketSummaryRequest,
        handleGetTicketSummaryRequest,
    );
}





function* rootTicketSaga() {
    yield all([
        handleCreateTicketRequest(),
        handleCreateTicketWatcher(),

        handleGetTicketRequest(),
        handleGetTicketWatcher(),

        handleGetAllTicketRequest(),
        handleGetAllTicketWatcher(),

        handleUpdateTicketRequest(),
        handleUpdateTicketWatcher(),

        handleDeleteTicketRequest(),
        handleDeleteTicketWatcher(),

        handleCreateTicketIssueTypeRequest(),
        handleCreateTicketIssueTypeWatcher(),

        handleGetAllTicketTypeRequest(),
        handleGetAllTicketTypeWatcher(),

        handleGetTicketIssueSubTypeRequest(),
        handleGetTicketIssueSubTypeWatcher(),

        handleGetAllTicketIssueTypeRequest(),
        handleGetAllTicketIssueTypeWatcher(),

        handleUpdateTicketTypeRequest(),
        handleUpdateTicketTypeWatcher(),

        handleDeleteTicketTypeRequest(),
        handleDeleteTicketTypeWatcher(),

        handleCreateTicketLogsRequest(),
        handleCreateTicketLogsWatcher(),

        handleGetTicketLogsRequest(),
        handleGetTicketLogsWatcher(),

        handleGetAllTicketLogsRequest(),
        handleGetAllTicketLogsWatcher(),

        handleUpdateTicketLogsRequest(),
        handleUpdateTicketLogsWatcher(),

        handleDeleteTicketLogsRequest(),
        handleDeleteTicketLogsWatcher(),

        handleCreateTicketSettingRequest(),
        handleCreateTicketSettingWatcher(),

        handleGetTicketSettingRequest(),
        handleGetTicketSettingWatcher(),

        handleGetAllTicketSettingRequest(),
        handleGetAllTicketSettingWatcher(),

        handleUpdateTicketSettingRequest(),
        handleUpdateTicketSettingWatcher(),

        handleDeleteTicketSettingRequest(),
        handleDeleteTicketSettingWatcher(),

        handleCreateHelpDeskRequest(),
        handleCreateHelpDeskWatcher(),

        handleGetHelpDeskRequest(),
        handleGetHelpDeskWatcher(),

        handleGetAllHelpDeskRequest(),
        handleGetAllHelpDeskWatcher(),

        handleUpdateHelpDeskRequest(),
        handleUpdateHelpDeskWatcher(),

        handleDeleteHelpDeskRequest(),
        handleDeleteHelpDeskWatcher(),

        handleGetTicketSummaryRequest(),
        handleGetTicketSummaryWatcher(),
    ]);
}

export default rootTicketSaga;
